const map = {
	"./24x7-cyber-experts.png": 1747,
	"./Annual.png": 3003,
	"./Card-delivery-fees.png": 8925,
	"./Card-replacement.png": 5655,
	"./Cash-Benefits.png": 5966,
	"./Category-what-is-covered.png": 2295,
	"./Category-what-is-not-covered.png": 443,
	"./Check-payment.png": 8513,
	"./Claims-investigation.png": 6488,
	"./Confidence-scams.png": 8878,
	"./Coverage-Periods.png": 9977,
	"./Covered by GCash-Visa.png": 9856,
	"./File-a-ticket.png": 9753,
	"./How-to-claim.png": 9577,
	"./Monthly.png": 2675,
	"./Policy-page-icon.png": 6998,
	"./Quarterly.png": 6701,
	"./Unauthorized-transactions.png": 1580,
	"./Voluntary-Disclosure.png": 3456,
	"./What-is-in-it-for-you.png": 4393,
	"assets/images/icons/24x7-cyber-experts.png": 1747,
	"assets/images/icons/Annual.png": 3003,
	"assets/images/icons/Card-delivery-fees.png": 8925,
	"assets/images/icons/Card-replacement.png": 5655,
	"assets/images/icons/Cash-Benefits.png": 5966,
	"assets/images/icons/Category-what-is-covered.png": 2295,
	"assets/images/icons/Category-what-is-not-covered.png": 443,
	"assets/images/icons/Check-payment.png": 8513,
	"assets/images/icons/Claims-investigation.png": 6488,
	"assets/images/icons/Confidence-scams.png": 8878,
	"assets/images/icons/Coverage-Periods.png": 9977,
	"assets/images/icons/Covered by GCash-Visa.png": 9856,
	"assets/images/icons/File-a-ticket.png": 9753,
	"assets/images/icons/How-to-claim.png": 9577,
	"assets/images/icons/Monthly.png": 2675,
	"assets/images/icons/Policy-page-icon.png": 6998,
	"assets/images/icons/Quarterly.png": 6701,
	"assets/images/icons/Unauthorized-transactions.png": 1580,
	"assets/images/icons/Voluntary-Disclosure.png": 3456,
	"assets/images/icons/What-is-in-it-for-you.png": 4393
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5016;